import React, { useEffect, useState } from "react";
import { Logo } from "../../../../images/Images";
import { CloseIcon, MenuIcon } from "../../../../components/icons/Icons";
import ArrowDownSvg from "../svgs/ArrowDown";
import AvatarSvg from "../svgs/AvatarSvg";
import "./RetailHeader.css";
import SearchSvg from "../svgs/SearchSvg";
import { useDispatch } from "react-redux";
import { logout } from "../../../../state/authSlice";
import LoadingComponent from "../../../../components/loading/Loading";

function RetailHeader() {
  const [activeId, setActiveId] = useState("");
  const [tabOpen, setTabOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const checkUserStatus = async () => {
    const token = localStorage.getItem("verify_status");
    if (token === "false") {
      window.location.href = "/verify-email";
    }
  };

  useEffect(() => {
    checkUserStatus();
  }, []);

  const dispatch = useDispatch();

  const handleLogout = () => {
    setLoading(true);
    dispatch(logout());

    setTimeout(() => {
      window.location.href = "/login";
    }, 3000);
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["home", "cart", "orders"];
      sections.forEach((id) => {
        const section = document.getElementById(id);
        if (section) {
          const { top, bottom } = section.getBoundingClientRect();
          if (top <= 100 && bottom >= 100) {
            setActiveId(id);
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleNav = () => {
    setTabOpen(!tabOpen);
    if (!tabOpen) {
      document.body.classList.add("locked");
    } else {
      document.body.classList.remove("locked");
    }
  };

  const width = window.innerWidth;

  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <div className="retail">
      <div className="home__header retail">
        <div
          className="logo"
          onClick={() => (window.location.href = "/retail")}
          style={{ cursor: "pointer" }}
        >
          <img src={Logo} alt="logo" />
        </div>

        <div className="navs">
          <ul className="navs__list">
            <div className="retail-header__search">
              <SearchSvg />
              <input
                type="text"
                className="retail-header__search-input"
                placeholder="Search..."
              />
            </div>

            <li className="navs__item">
              <a
                href="/all-vendors"
                className={`navs__link navs__link-home${
                  activeId === "home" ? " navs__link--active" : ""
                }`}
              >
                Home
              </a>
            </li>
            {/* <li className="navs__item">
              <a
                href="/retail-carts"
                className={`navs__link navs__link-cart${
                  activeId === "contact" ? " navs__link--active" : ""
                }`}
              >
                Cart
              </a>
            </li> */}
            <li className="navs__item">
              <a
                href="/retail-orders"
                className={`navs__link navs__link-orders${
                  activeId === "faq" ? " navs__link--active" : ""
                }`}
                style={{ display: "flex", alignItems: "center" }}
              >
                <p>Orders</p>
              </a>
            </li>

            <li className="navs__item">
              <a
                href="/retail-profile"
                className={`navs__link ${
                  activeId === "faq" ? "navs__link--active" : ""
                }`}
                style={{ display: "flex", alignItems: "center" }}
              >
                <AvatarSvg />
              </a>
            </li>
          </ul>
        </div>
      </div>

      {tabOpen && (
        <div className="navs mobile">
          <ul className="navs__list">
            <li className="navs__item">
              <a
                href="/all-vendors"
                className={`navs__link navs__link-home${
                  activeId === "home" ? " navs__link--active" : ""
                }`}
              >
                Home
              </a>
            </li>
            <li className="navs__item">
              <a
                href="#contact"
                className={`navs__link navs__link-cart${
                  activeId === "contact" ? " navs__link--active" : ""
                }`}
              >
                Cart
              </a>
            </li>
            <li className="navs__item">
              <a
                href="#faq"
                className={`navs__link navs__link-orders${
                  activeId === "faq" ? " navs__link--active" : ""
                }`}
              >
                Orders
              </a>
            </li>
          </ul>
          {/* Profile icon at the bottom */}
          <div className="mobile-nav-profile-link">
            <a href="/retail-profile">
              <AvatarSvg />
              <span>Profile</span>
            </a>
          </div>
        </div>
      )}

      {width <= 900 && (
        <div className="mobile__nav_retailer">
          <div className="logo">
            <img src={Logo} alt="logo" />
          </div>

          <div className="nav__burger">
            {tabOpen ? (
              <CloseIcon onClick={toggleNav} />
            ) : (
              <MenuIcon onClick={toggleNav} />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default RetailHeader;
